(function () {
    "use strict";

    angular
        .module("app")
        .directive("basicColorSearchHelp", ["SearchFactory", basicColorSearchHelp]);

    function basicColorSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.basicColorKey = "";
                        scope.basicColorName = "";
                        scope.nrfId = "";
                        scope.nrfName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.basicColorKey === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.basicColorSearch(function (basicColor) {
                        scope.basicColorKey = basicColor ? basicColor.BasicColorKey : "";
                        scope.basicColorName = basicColor ? basicColor.BasicColorName : "";
                        scope.nrfId = basicColor ? basicColor.NRFId : "";
                        scope.nrfName = basicColor ? basicColor.NRFName : "";
                        scope.displayValue = scope.basicColorName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.$watch("basicColorName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.basicColorKey;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { basicColorKey: "=", basicColorName: "=?", nrfId: "=?", nrfName: "=?", readOnly: "=", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

